export const bankingDe = {
  pages: {
    accounts: 'Bankkonten',
    accountsSubtitle: 'Eigene Konten, Open-Banking-Verbindungen und aktuelle Salden.',
    transactions: 'Banktransaktionen',
    transactionsSubtitle: 'Unveränderliche Bankumsätze aus Kontoauszügen und Open Banking.',
    reconciliation: 'Bankabgleich',
    reconciliationSubtitle:
      'Bereits erfolgte Bankumsätze nachvollziehbar offenen Posten zuordnen und im ERP verbuchen.',
    payments: 'Zahlungszuordnungen',
    paymentsSubtitle:
      'Interne OPOS-Buchungen aus dem Bankabgleich; hier wird keine Überweisung ausgelöst.',
    settings: 'Banking-Einstellungen',
    settingsSubtitle: 'Provider, Synchronisation, Matching, Kontierung und Importprofile.',
  },
  actions: {
    sync: 'Jetzt synchronisieren',
    refreshStatus: 'Status aktualisieren',
    renew: 'Einwilligung erneuern',
    suspend: 'Verbindung sperren',
    resume: 'Verbindung fortsetzen',
    revoke: 'Verbindung widerrufen',
    generate: 'Vorschläge erzeugen',
    reconcile: 'Abgleichen',
    confirm: 'Zuordnung bestätigen',
    post: 'Im ERP verbuchen',
    ignore: 'Ignorieren',
    reverse: 'Buchung stornieren',
    addAllocation: 'Posten zuordnen',
    removeAllocation: 'Zuordnung entfernen',
    clearFilters: 'Filter zurücksetzen',
  },
  readOnly: {
    title: 'Nur lesender Bankzugriff',
    description:
      'Das ERP ruft Kontoinformationen und vorhandene Banktransaktionen ab. Es kann keine Überweisung erstellen, freigeben oder an eine Bank senden.',
  },
  dashboard: {
    connectedAccounts: 'Verbundene Konten',
    balances: 'Kontostände',
    newIncoming: 'Neue Zahlungseingänge',
    recognized: 'Automatisch erkannt',
    manualReview: 'Manuell zu prüfen',
    posted: 'Vollständig gebucht',
    conflicts: 'Konflikte',
    unknown: 'Unbekannte Zahlungen',
    overdue: 'Überfällige OPOS',
    nextAuthentication: 'Nächste Bankauthentifizierung',
    lastSync: 'Letzter erfolgreicher Sync',
  },
  accounts: {
    account: 'Konto',
    holder: 'Kontoinhaber',
    iban: 'IBAN',
    bic: 'BIC',
    bank: 'Bank',
    balance: 'Saldo',
    accountingAccount: 'Buchhaltungskonto',
    connectionType: 'Verbindung',
    default: 'Standardkonto',
    connection: 'Bankverbindung',
    consentUntil: 'Einwilligung gültig bis',
    noAccounts: 'Noch keine Bankkonten vorhanden.',
    noConnections: 'Keine Open-Banking-Verbindung vorhanden.',
    dynamicCoverage: 'Die Bankabdeckung stammt dynamisch aus dem Provider-Verzeichnis.',
    connectBank: 'Bank verbinden',
    connectTitle: 'Open-Banking-Verbindung starten',
    connectDescription:
      'Authentifizierung und SCA erfolgen bei der Bank beziehungsweise beim regulierten Provider. Das ERP fragt niemals Passwort oder TAN ab.',
    country: 'Land',
    germany: 'Deutschland',
    france: 'Frankreich',
    institutionSearch: 'Bank im aktuellen Provider-Verzeichnis suchen',
    chooseInstitution: 'Bank auswählen',
    businessSupport: 'Geschäftskonten',
    supported: 'unterstützt',
    unknownSupport: 'vom Provider nicht ausgewiesen',
    accountSelection: 'Freigegebene Konten auswählen',
    selectAccounts: 'Ausgewählte Konten übernehmen',
    openBankingOptional: 'Open Banking ist optional und derzeit deaktiviert',
    openBankingOptionalHint:
      'Bankkonten, CAMT-/MT940-/CSV-Import und Zahlungsabgleich funktionieren ohne Provider. Ein Mandant kann Open Banking später in den Banking-Einstellungen aktivieren.',
  },
  transactions: {
    search: 'Referenz, Gegenpartei oder Verwendungszweck suchen',
    date: 'Buchungsdatum',
    counterparty: 'Gegenpartei',
    purpose: 'Verwendungszweck',
    amount: 'Betrag',
    source: 'Quelle',
    status: 'Abgleichstatus',
    bookingStatus: 'Bankstatus',
    account: 'Bankkonto',
    noTransactions: 'Keine Banktransaktionen für diese Filter gefunden.',
    sensitiveHidden: 'Sensible Bankdetails sind durch die Berechtigung eingeschränkt.',
  },
  reconciliation: {
    selectTransaction: 'Banktransaktion auswählen',
    selectHint: 'Wählen Sie links einen Umsatz aus, um Vorschläge und offene Posten zu prüfen.',
    suggestions: 'Matching-Vorschläge',
    noSuggestions: 'Noch keine Vorschläge vorhanden.',
    confidence: 'Konfidenz',
    reasoning: 'Begründung',
    fulfilled: 'Erfüllte Kriterien',
    missing: 'Fehlende Kriterien',
    conflicts: 'Widersprüche',
    alternatives: 'Alternative Treffer',
    openItems: 'Offene Posten',
    openItemsSearch: 'Belegnummer oder Geschäftspartner suchen',
    selectedItems: 'Ausgewählte Posten',
    allocationAmount: 'Zahlbetrag',
    cashDiscount: 'Skonto',
    remaining: 'Restbetrag',
    bankFee: 'Gebühr',
    comment: 'Kommentar',
    commentPlaceholder: 'Grundlage der manuellen Zuordnung',
    ignoreReason: 'Grund für das Ignorieren',
    ignoreReasonPlaceholder: 'Warum wird dieser Umsatz nicht abgeglichen?',
    splitDesktopHint: 'Split-Zuordnungen sind für größere Bildschirme optimiert.',
    manualNotice:
      'Manuelle Zuordnungen werden mit 100 % als Benutzerentscheidung protokolliert, nicht als automatische Erkennung.',
    dropHint: 'Offenen Posten auswählen oder den Umsatz hierher ziehen.',
    posted: 'Der vorhandene Bankumsatz wurde im ERP verbucht.',
    matched: 'Die Zuordnung wurde gespeichert.',
    ignored: 'Der Umsatz wurde mit Begründung ignoriert.',
  },
  payments: {
    posting: 'Buchung',
    kind: 'Zahlungsart',
    bookingDate: 'Buchungsdatum',
    amount: 'Betrag',
    mode: 'Modus',
    status: 'Status',
    related: 'Verknüpfungen',
    reason: 'Stornogrund',
    reasonPlaceholder: 'Nachvollziehbare Begründung (mindestens 10 Zeichen)',
    noPostings: 'Noch keine Bankabgleichsbuchungen vorhanden.',
    reversed: 'Die Buchung wurde kontrolliert storniert.',
  },
  fields: {
    allStatuses: 'Alle Status',
    allAccounts: 'Alle Konten',
    allTypes: 'Alle Arten',
    from: 'Von',
    to: 'Bis',
  },
  states: {
    loading: 'Banking-Daten werden geladen …',
    error: 'Banking-Daten konnten nicht geladen werden.',
    saved: 'Gespeichert',
    queued: 'Synchronisation wurde eingeplant.',
  },
  status: {
    NEW: 'Neu',
    UNMATCHED: 'Nicht zugeordnet',
    PROPOSED: 'Vorgeschlagen',
    PARTIALLY_MATCHED: 'Teilweise zugeordnet',
    MATCHED: 'Zugeordnet',
    POSTED: 'Gebucht',
    IGNORED: 'Ignoriert',
    CONFLICT: 'Konflikt',
    REVERSED: 'Storniert',
    CREATED: 'Erstellt',
    REDIRECT_REQUIRED: 'Weiterleitung erforderlich',
    AUTHORIZING: 'Autorisierung läuft',
    LINKED: 'Verbunden',
    PENDING: 'Vorgemerkt',
    BOOKED: 'Gebucht',
    ACTIVE: 'Aktiv',
    ARCHIVED: 'Archiviert',
    ERROR: 'Fehler',
    SCA_REQUIRED: 'SCA erforderlich',
    EXPIRED: 'Einwilligung abgelaufen',
    READY: 'Bereit',
    SUSPENDED: 'Gesperrt',
    REVOKED: 'Widerrufen',
  },
  kind: {
    CUSTOMER_RECEIPT: 'Kundenzahlung',
    VENDOR_PAYMENT: 'Lieferantenzahlung',
    CUSTOMER_REFUND: 'Kundenerstattung',
    VENDOR_REFUND: 'Lieferantenerstattung',
    OWN_TRANSFER: 'Erkannter Eigenkonto-Umsatz',
    BANK_FEE: 'Bankgebühr',
    INTEREST: 'Zinsen',
    CHARGEBACK: 'Rücklastschrift',
    EXISTING_CUSTOMER_PAYMENT: 'Bestehende Kundenzahlung',
    DUPLICATE: 'Dublette',
  },
  type: {
    CUSTOMER_INVOICE: 'Ausgangsrechnung',
    CUSTOMER_CREDIT_NOTE: 'Gutschrift',
    VENDOR_INVOICE: 'Eingangsrechnung',
  },
  links: {
    transaction: 'Banktransaktion',
    document: 'Beleg',
    partner: 'Geschäftspartner',
  },
  mode: {
    MANUAL: 'Manuell',
    AUTOMATIC: 'Automatisch',
  },
  settings: {
    policyTitle: 'Synchronisation und Zahlungsabgleich',
    policyDescription:
      'Mandantenbezogene Regeln für Abruf, deterministisches Matching, Buchung und Aufbewahrung.',
    emergencyStop: 'Globale Notabschaltung',
    emergencyStopHint:
      'Stoppt neue und wartende Banksynchronisationen dieses Mandanten. Verbindungen und Quelldaten bleiben erhalten.',
    syncInterval: 'Sync-Intervall in Minuten',
    amountTolerance: 'Betragstoleranz',
    dateTolerance: 'Datumstoleranz in Tagen',
    cashDiscountTolerance: 'Skontotoleranz',
    confidenceThreshold: 'Konfidenzschwelle in Prozent',
    maxCombinationSize: 'Maximale Sammelzuordnung',
    maxAlternatives: 'Maximale Alternativtreffer',
    statementRetention: 'Aufbewahrung Originalauszüge in Tagen',
    transactionRetention: 'Aufbewahrung Banktransaktionen in Tagen',
    feeAccount: 'Gebührenkonto',
    interestAccount: 'Zinskonto',
    suspenseAccount: 'Konto ungeklärte Zahlungen',
    automaticPosting: 'Automatische ERP-Verbuchung',
    automaticPostingHint:
      'Standardmäßig aus. Ordnet nur bereits erfolgte Bankumsätze intern zu; es wird niemals eine Überweisung ausgelöst. Aktivierung erfordert banking:auto_post.',
    retentionHint:
      'Die Fristen sind eine Betriebsrichtlinie. Gesetzliche Aufbewahrung, Sperrvermerke und Legal Holds sind vor einer Löschung gesondert zu prüfen.',
    save: 'Einstellungen speichern',
    saved: 'Banking-Einstellungen wurden gespeichert.',
    providerDescription:
      'Regulatorische und vertragliche Freigabe je Mandant. Abdeckung wird niemals statisch zugesichert.',
    aispOnly: 'Nur Kontoinformationen (AISP)',
    credentialsTitle: 'Getrennte Provider-Zugangsdaten',
    credentialsHint:
      'Mandanteneigene API-Zugangsdaten des AISP werden verschlüsselt und nur schreibend gespeichert. Dies sind niemals Bankpasswort oder TAN. Status:',
    providerClientId: 'Provider Client-ID / Secret-ID',
    providerClientSecret: 'Provider Client-Secret / Secret-Key',
    credentialsUnchanged: 'Gespeicherter Wert bleibt unverändert',
    credentialsPairRequired: 'Client-ID und Client-Secret müssen gemeinsam eingegeben werden.',
    clearCredentials: 'Provider-Zugangsdaten entfernen',
    clearCredentialsHint: 'Deaktiviert den Provider; bestehende Bankquelldaten bleiben erhalten.',
    credentialStorageUnavailable: 'Verschlüsselte Providerablage nicht aktiviert',
    credentialStorageUnavailableHint:
      'Manuelle Kontoauszüge funktionieren weiterhin. Für Open Banking muss der ERP-Betreiber einmalig einen Banking-Verschlüsselungsschlüssel konfigurieren.',
    configured: 'konfiguriert',
    notConfigured: 'nicht konfiguriert',
    register: 'EBA-Register',
    privacy: 'Datenschutz',
    terms: 'Vertragsbedingungen',
    subprocessors: 'Unterauftragnehmer',
    dynamicCoverageNotice:
      'Deutschland und Frankreich sind Zielmärkte. Die konkrete Bank- und Geschäftskontenabdeckung stammt live aus dem Provider-Verzeichnis.',
    environment: 'Provider-Umgebung',
    providerEnabled: 'Provider aktiviert',
    registerCheckedAt: 'Register geprüft am',
    contractApprovedAt: 'Vertrag freigegeben am',
    privacyReviewedAt: 'Datenschutzrolle geprüft am',
    subprocessorsReviewedAt: 'Unterauftragnehmer geprüft am',
    registerUrl: 'Offizielle Registerquelle',
    registerEntity: 'Registereintrag / Rechtsträger',
    registerReference: 'Registerreferenz',
    contractReference: 'Interne Vertragsfreigabe',
    privacyReference: 'Interne Datenschutzprüfung',
    subprocessorVersion: 'Version der Lieferantenliste',
    notes: 'Freigabehinweise',
    webhook: 'Signierten Webhook aktivieren',
    rotateWebhook: 'Webhook-Secret rotieren',
    webhookSecretOnce: 'Secret jetzt sicher übernehmen – es wird nur einmal angezeigt',
    saveProvider: 'Providerfreigabe speichern',
    providerSaved: 'Providerkonfiguration wurde gespeichert.',
    accountMappingTitle: 'Kontenzuordnung',
    accountMappingDescription: 'Jedes eigene Bankkonto einem Buchhaltungskonto zuordnen.',
    mappingSaved: 'Kontenzuordnung wurde gespeichert.',
    importProfilesTitle: 'CAMT- und CSV-Importprofile',
    importProfilesDescription:
      'CAMT wird namespacesicher erkannt; bankspezifische CSV-Spalten werden explizit abgebildet.',
    camtBuiltIn: '{{count}} ISO-20022-Namespaces sind als geprüfte Systemprofile hinterlegt.',
    profileName: 'Profilname',
    delimiter: 'Trennzeichen',
    quoteCharacter: 'Textbegrenzer',
    encoding: 'Zeichensatz',
    dateFormat: 'Datumsformat',
    decimalSeparator: 'Dezimaltrenner',
    hasHeader: 'Kopfzeile vorhanden',
    columnMapping: 'Spaltenzuordnung (JSON)',
    invalidMapping: 'Die Spaltenzuordnung ist kein gültiges Banking-CSV-Profil.',
    createProfile: 'CSV-Profil anlegen',
    archiveProfile: 'Profil archivieren',
    activateProfile: 'Profil aktivieren',
    csvSaved: 'CSV-Importprofil wurde gespeichert.',
  },
} as const;

export const bankingEn = {
  ...bankingDe,
  pages: {
    accounts: 'Bank accounts',
    accountsSubtitle: 'Own accounts, open-banking connections, and current balances.',
    transactions: 'Bank transactions',
    transactionsSubtitle: 'Immutable bank entries from statements and open banking.',
    reconciliation: 'Bank reconciliation',
    reconciliationSubtitle:
      'Assign existing bank transactions to open items and post the result inside the ERP.',
    payments: 'Payment allocations',
    paymentsSubtitle:
      'Internal open-item postings from reconciliation; no bank transfer can be initiated here.',
    settings: 'Banking settings',
    settingsSubtitle: 'Provider, synchronization, matching, account mapping, and import profiles.',
  },
  actions: {
    ...bankingDe.actions,
    sync: 'Sync now',
    generate: 'Generate suggestions',
    reconcile: 'Reconcile',
    confirm: 'Confirm assignment',
    post: 'Post in ERP',
    ignore: 'Ignore',
    reverse: 'Reverse posting',
  },
  accounts: {
    ...bankingDe.accounts,
    openBankingOptional: 'Open Banking is optional and currently disabled',
    openBankingOptionalHint:
      'Bank accounts, CAMT/MT940/CSV imports, and reconciliation work without a provider. A tenant can enable Open Banking later in banking settings.',
  },
  readOnly: {
    title: 'Read-only bank access',
    description:
      'The ERP retrieves account information and existing bank transactions. It cannot create, authorize, or send a bank transfer.',
  },
  states: {
    ...bankingDe.states,
    loading: 'Loading banking data …',
    error: 'Banking data could not be loaded.',
  },
  settings: {
    ...bankingDe.settings,
    policyTitle: 'Synchronization and reconciliation',
    policyDescription:
      'Tenant-specific rules for retrieval, deterministic matching, posting, and retention.',
    emergencyStop: 'Global emergency stop',
    emergencyStopHint:
      'Stops new and queued bank syncs for this tenant. Connections and source data remain intact.',
    syncInterval: 'Sync interval in minutes',
    amountTolerance: 'Amount tolerance',
    dateTolerance: 'Date tolerance in days',
    cashDiscountTolerance: 'Cash discount tolerance',
    confidenceThreshold: 'Confidence threshold in percent',
    maxCombinationSize: 'Maximum batch allocation',
    maxAlternatives: 'Maximum alternative matches',
    statementRetention: 'Original statement retention in days',
    transactionRetention: 'Bank transaction retention in days',
    feeAccount: 'Bank fee account',
    interestAccount: 'Interest account',
    suspenseAccount: 'Unresolved payments account',
    automaticPosting: 'Automatic ERP posting',
    automaticPostingHint:
      'Off by default. This only allocates existing bank transactions inside the ERP and never initiates a transfer. Enabling requires banking:auto_post.',
    retentionHint:
      'These periods are an operating policy. Statutory retention, holds, and legal preservation must be checked before deletion.',
    save: 'Save settings',
    saved: 'Banking settings saved.',
    providerDescription:
      'Regulatory and contractual approval per tenant. Coverage is never guaranteed statically.',
    aispOnly: 'Account information only (AISP)',
    credentialsTitle: 'Separate provider credentials',
    credentialsHint:
      'The tenant’s own AISP API credentials are encrypted and write-only. They are never an online-banking password or TAN. Status:',
    providerClientId: 'Provider client ID / secret ID',
    providerClientSecret: 'Provider client secret / secret key',
    credentialsUnchanged: 'Stored value remains unchanged',
    credentialsPairRequired: 'Client ID and client secret must be entered together.',
    clearCredentials: 'Remove provider credentials',
    clearCredentialsHint: 'Disables the provider; existing bank source data is retained.',
    credentialStorageUnavailable: 'Encrypted provider storage is not enabled',
    credentialStorageUnavailableHint:
      'Manual statements remain available. The ERP operator must configure a banking encryption key once before Open Banking can be used.',
    configured: 'configured',
    notConfigured: 'not configured',
    register: 'EBA register',
    privacy: 'Privacy',
    terms: 'Terms',
    subprocessors: 'Subprocessors',
    dynamicCoverageNotice:
      'Germany and France are target markets. Actual bank and business-account coverage comes live from the provider directory.',
    environment: 'Provider environment',
    providerEnabled: 'Provider enabled',
    registerCheckedAt: 'Register checked at',
    contractApprovedAt: 'Contract approved at',
    privacyReviewedAt: 'Privacy role reviewed at',
    subprocessorsReviewedAt: 'Subprocessors reviewed at',
    registerUrl: 'Official register source',
    registerEntity: 'Registered entity',
    registerReference: 'Register reference',
    contractReference: 'Internal contract approval',
    privacyReference: 'Internal privacy review',
    subprocessorVersion: 'Supplier-list version',
    notes: 'Approval notes',
    webhook: 'Enable signed webhook',
    rotateWebhook: 'Rotate webhook secret',
    webhookSecretOnce: 'Store this secret securely now — it is shown once',
    saveProvider: 'Save provider approval',
    providerSaved: 'Provider configuration saved.',
    accountMappingTitle: 'Account mapping',
    accountMappingDescription: 'Map each own bank account to a ledger account.',
    mappingSaved: 'Account mapping saved.',
    importProfilesTitle: 'CAMT and CSV import profiles',
    importProfilesDescription:
      'CAMT namespaces are detected securely; bank-specific CSV columns are mapped explicitly.',
    camtBuiltIn: '{{count}} ISO 20022 namespaces are available as verified system profiles.',
    profileName: 'Profile name',
    delimiter: 'Delimiter',
    quoteCharacter: 'Quote character',
    encoding: 'Encoding',
    dateFormat: 'Date format',
    decimalSeparator: 'Decimal separator',
    hasHeader: 'Header row present',
    columnMapping: 'Column mapping (JSON)',
    invalidMapping: 'The column mapping is not a valid banking CSV profile.',
    createProfile: 'Create CSV profile',
    archiveProfile: 'Archive profile',
    activateProfile: 'Activate profile',
    csvSaved: 'CSV import profile saved.',
  },
} as const;

export const bankingTr = bankingEn;

export const bankingFr = {
  ...bankingEn,
  pages: {
    accounts: 'Comptes bancaires',
    accountsSubtitle: 'Comptes propres, connexions open banking et soldes actuels.',
    transactions: 'Transactions bancaires',
    transactionsSubtitle: 'Écritures bancaires immuables issues des relevés et de l’open banking.',
    reconciliation: 'Rapprochement bancaire',
    reconciliationSubtitle:
      'Affecter les transactions bancaires existantes aux postes ouverts dans l’ERP.',
    payments: 'Affectations de paiements',
    paymentsSubtitle:
      'Comptabilisations internes issues du rapprochement ; aucun virement bancaire ne peut être initié ici.',
    settings: 'Paramètres bancaires',
    settingsSubtitle:
      'Fournisseur, synchronisation, rapprochement, imputation et profils d’import.',
  },
  readOnly: {
    title: 'Accès bancaire en lecture seule',
    description:
      'L’ERP récupère les informations de compte et les transactions existantes. Il ne peut ni créer, ni autoriser, ni envoyer de virement bancaire.',
  },
  accounts: {
    ...bankingEn.accounts,
    openBankingOptional: 'L’Open Banking est facultatif et actuellement désactivé',
    openBankingOptionalHint:
      'Les comptes, les imports CAMT/MT940/CSV et le rapprochement fonctionnent sans fournisseur. Un tenant peut activer l’Open Banking ultérieurement dans les paramètres.',
  },
  settings: {
    ...bankingEn.settings,
    policyTitle: 'Synchronisation et rapprochement',
    emergencyStop: 'Arrêt d’urgence global',
    emergencyStopHint:
      'Arrête les nouvelles synchronisations et celles en attente pour ce tenant sans supprimer les données sources.',
    automaticPosting: 'Comptabilisation automatique dans l’ERP',
    automaticPostingHint:
      'Désactivée par défaut. Elle affecte uniquement des transactions bancaires existantes dans l’ERP et ne déclenche jamais de virement. Son activation exige banking:auto_post.',
    providerDescription:
      'Validation réglementaire et contractuelle par tenant. La couverture bancaire ne fait jamais l’objet d’une promesse statique.',
    aispOnly: 'Informations de compte uniquement (AISP)',
    credentialsHint:
      'Les identifiants API AISP propres au tenant sont chiffrés et accessibles uniquement en écriture. Ils ne sont jamais un mot de passe bancaire ni un TAN. Statut :',
    providerClientId: 'Identifiant client / Secret ID du fournisseur',
    providerClientSecret: 'Secret client / Secret Key du fournisseur',
    credentialsUnchanged: 'La valeur enregistrée reste inchangée',
    credentialsPairRequired: 'L’identifiant et le secret client doivent être saisis ensemble.',
    clearCredentials: 'Supprimer les identifiants du fournisseur',
    clearCredentialsHint:
      'Désactive le fournisseur ; les données bancaires existantes sont conservées.',
    credentialStorageUnavailable: 'Stockage chiffré du fournisseur non activé',
    credentialStorageUnavailableHint:
      'Les relevés manuels restent disponibles. L’exploitant ERP doit configurer une fois une clé de chiffrement bancaire avant d’utiliser l’Open Banking.',
    dynamicCoverageNotice:
      'L’Allemagne et la France sont les marchés cibles. La couverture réelle provient en direct de l’annuaire du fournisseur.',
  },
} as const;

export const bankingEs = bankingEn;
export const bankingRu = bankingEn;
